import { Routes } from '@angular/router';
import { authGuard } from '@core/guards/auth.guard';
import { roleGuard } from '@core/guards/role.guard';
import { AuthLayoutComponent } from '@core/layouts/auth/auth-layout/auth-layout.component';
import { ContentLayoutComponent } from '@core/layouts/main/content-layout/content-layout.component';
import { UnauthorizedComponent } from '@pages/unauthorized/unauthorized/unauthorized.component';
import { RoutePaths } from '@routes';

export const routes: Routes = [
  // Public (Authentication) Routes
  {
    path: '',
    component: AuthLayoutComponent,
    loadChildren: () =>
      import('./pages/auth/auth.routes').then((m) => m.authRoutes),
  },

  // Protected Routes
  {
    path: '',
    component: ContentLayoutComponent,
    canActivate: [authGuard], // First check: user must be logged in
    children: [
      {
        path: '',
        canActivate: [roleGuard],
        data: { roles: ['user', 'admin', 'subadmin'] }, // ✅ Allow subadmin
        loadChildren: () =>
          import('./pages/others/others.routes').then((m) => m.othersRoutes),
      },

      {
        path: RoutePaths.SUBSCRIPTIONS,
        canActivate: [roleGuard],
        data: { roles: ['user'] }, // ✅ Allow subadmin
        loadChildren: () =>
          import('./pages/subscriptions/package.routes').then(
            (m) => m.packageRoutes
          ),
      },

      {
        path: RoutePaths.PROMPT,
        canActivate: [roleGuard],
        data: { roles: ['user'] }, // ❌ Only for users
        loadChildren: () =>
          import('./pages/chats/chats.routes').then((m) => m.chatsRoutes),
      },

      {
        path: RoutePaths.CHAT_HISTORY,
        canActivate: [roleGuard],
        data: { roles: ['user'] }, // ❌ Only for users
        loadChildren: () =>
          import('./pages/chat-history/history.routes').then(
            (m) => m.historyRoutes
          ),
      },

      {
        path: RoutePaths.ADMIN,
        canActivate: [roleGuard],
        data: { roles: ['admin', 'subadmin'] }, // ✅ Both admin and subadmin
        loadChildren: () =>
          import('./pages/admin/admin.routes').then((m) => m.adminRoutes),
      },

      // Fallbacks
      {
        path: RoutePaths.UNAUTHORIZED,
        component: UnauthorizedComponent,
      },
      {
        path: '**',
        redirectTo: RoutePaths.UNAUTHORIZED,
      },
    ],
  },
];
